import React from 'react';

import BasePage from 'components/utils/BasePage';

import PromoSpinner from '../components/no-auth/common/PromoSpinner/PromoSpinner';

const WhiteScreenMobileAppPage = () => {
    return <PromoSpinner forceShow={true} />;
};

export default BasePage(WhiteScreenMobileAppPage);
